module.exports = __webpack_public_path__ + "img/logo_login.3b0c9175.png";